export default "query getCofaceWebAssicuratiEndpoint {\n    getCofaceWebAssicuratiEndpoint\n}";